var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4468 9.34734L19.2356 6.81724C19.7192 6.13379 20.0967 5.21717 20.0789 4.77C20.0607 4.32245 19.6828 3.94556 19.2339 3.92675C18.7854 3.90856 17.8677 4.28577 17.1843 4.76932L14.6539 6.55876L7.58875 3.18367C6.83367 2.82299 5.84033 3.0097 5.37058 3.60195C4.90082 4.1942 5.04516 5.10377 5.69297 5.6344L11.3407 10.2606L7.11838 14.9386L5.12664 14.3372C4.32546 14.0946 3.42802 14.1316 3.12314 14.4186C2.81795 14.706 3.09957 15.3638 3.75208 15.8885L5.5594 17.3415C5.5594 17.3415 5.4914 17.6574 5.40696 18.0474C5.32282 18.4371 5.56985 18.6834 5.95918 18.5972L6.66378 18.4408L8.1158 20.2474C8.64074 20.8999 9.29894 21.1819 9.58631 20.8773C9.87337 20.5728 9.91037 19.6764 9.66773 18.8748L9.06601 16.8825L13.7433 12.6601L18.3702 18.3083C18.9005 18.956 19.8104 19.1004 20.4026 18.6303C20.9945 18.1605 21.182 17.1669 20.8209 16.4114L17.4468 9.34734Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelIcon);
export default __webpack_public_path__ + "static/media/travel_icon.950c434c9feac80f7e3952a25c998e69.svg";
export { ForwardRef as ReactComponent };